module.exports = __webpack_public_path__ + "img/qihuoshangpin_head.ca7ede99.png";